import script from "./GalleryImage.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryImage.vue?vue&type=script&setup=true&lang=js"

import "./GalleryImage.vue?vue&type=style&index=0&id=63d0fd1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d0fd1d"]])

export default __exports__